<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><span aria-label="iv" class="page" id="piv" role="doc-pagebreak"></span>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2020 by The University of Chicago</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.</p>
<p class="crt">Published 2020</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">29 28 27 26 25 24 23 22 21 20    1 2 3 4 5</p>
<p class="crtf">ISBN-13: 978-0-226-69173-2 (cloth)</p>
<p class="crt">ISBN-13: 978-0-226-69187-9 (paper)</p>
<p class="crt">ISBN-13: 978-0-226-69190-9 (e-book)</p>
<p class="crt">DOI: <a class="url" href="https://doi.org/10.7208/chicago/9780226691909.001.0001" target="_blank">https://doi.org/10.7208/chicago/9780226691909.001.0001</a></p>
<p class="cipf">“A Litany for Survival.” Copyright © 1978 by Audre Lorde, from The Collected Poems of Audre Lorde by Audre Lorde. Used by permission of W. W. Norton &amp; Company, Inc.</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Condon, Meghan, author. | Wichowsky, Amber, author.</p>
<p class="cip">Title: The economic other : inequality in the American political imagination / Meghan Condon, Amber Wichowsky.</p>
<p class="cip">Description: Chicago ; London : The University of Chicago Press, 2020. | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: LCCN 2019050467 | ISBN 9780226691732 (cloth) | ISBN 9780226691879 (paperback) | ISBN 9780226691909 (ebook)</p>
<p class="cip">Subjects: LCSH: Equality—United States—Public opinion. | Social comparison—Political aspects—United States. | Income distribution— Political aspects—United States.</p>
<p class="cip">Classification: LCC JC575 .C663 2020 | DDC 320.973/09051—dc23</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2019050467" target="_blank">https://lccn.loc.gov/2019050467</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of ANSI<span class="sm">/</span>NISO Z39.48–1992 (Permanence of Paper).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-condon-0004.vue?a9bd8a20